// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { JsonValueSchema } from '../inputTypeSchemas/JsonValueSchema'
import { HttpMethodSchema } from '../inputTypeSchemas/HttpMethodSchema'
import { EndpointApiTypeSchema } from '../inputTypeSchemas/EndpointApiTypeSchema'
import { DiscoveryAuthModeSchema } from '../inputTypeSchemas/DiscoveryAuthModeSchema'
import { DiscoverySourceSchema } from '../inputTypeSchemas/DiscoverySourceSchema'
import { EndpointCandidateVerificationStatusSchema } from '../inputTypeSchemas/EndpointCandidateVerificationStatusSchema'

/////////////////////////////////////////
// ENDPOINT CANDIDATE SCHEMA
/////////////////////////////////////////

export const EndpointCandidateSchema = z.object({
  method: HttpMethodSchema,
  apiType: EndpointApiTypeSchema,
  authMode: DiscoveryAuthModeSchema,
  source: DiscoverySourceSchema,
  verificationStatus: EndpointCandidateVerificationStatusSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  applicationId: z.string(),
  credentialIds: z.string().array(),
  url: z.string(),
  uri: z.string().nullable(),
  hash: z.string(),
  graphqlOperationName: z.string().nullable(),
  soapOperationName: z.string().nullable(),
  xmlOperationName: z.string().nullable(),
  mcpOperationName: z.string().nullable(),
  grpcServiceName: z.string().nullable(),
  grpcMethodName: z.string().nullable(),
  sourceDetail: z.string().nullable(),
  endpointId: z.string().nullable(),
  webpageId: z.string().nullable(),
  httpVersion: z.string().nullable(),
  headersSize: z.number().int().nullable(),
  bodySize: z.number().int().nullable(),
  requiresHumanVerification: z.boolean(),
  failureReason: z.string().nullable(),
  probeVerdictData: JsonValueSchema.nullable(),
  probeDispatchedAt: z.coerce.date().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date().nullable(),
})

export type EndpointCandidate = z.infer<typeof EndpointCandidateSchema>

export default EndpointCandidateSchema;
